export const planInfo = {
  plan_soiltest: {
    name: "Single Soil Test",
    description: "Single soil test for analysis and recommendations.",
  },
  plan_basic: {
    name: "Basic Plan",
    description:
      "Access 4 soil tests, crop doctor, AI advisory and basic Package of Practices.",
  },
  plan_premium: {
    name: "Premium Plan",
    description:
      "All features of Basic Plan, plus satellite data and advanced Package of Practices.",
  },
};
